import React, { useState, useEffect } from 'react';

import moment from 'moment';
import { Link } from 'react-router-dom';

import { config } from '../../../../config/index';

import {
  toWeekInt,
  toWeekDaysArrayFull,
  toWeekStartDate,
} from '../../../../helpers/moment';

const { API_URL } = config;

const PerformanceTab = ({
  activeDate,
  activeSchedules,
  associate,
  activeWeek,
  activeClient,
  activeSite
}) => {
  const token = localStorage.getItem('token');
  const [scores, setScores] = useState({});

  // Fetch Associate Performance
  useEffect(() => {
    const fetchAssociatePerformance = async () => {
      let url = `${API_URL}/associate/${associate.id}/performance`;

      try {
        let response = await fetch(url, {
          mode: 'cors',
          method: 'GET',
          withCredentials: true,
          headers: {
            Authorization: token,
            'Access-Control-Allow-Origin': '*',
            'Content-Type': 'application/json; charset=utf-8',
          },
        });

        let json = await response.json();
        if (response.ok) {
          let filtered =
            json.data.length > 0 &&
            json.data.find(
              (performance) =>
                moment(performance.week_start_date, 'YYYY-MM-DD') >=
                moment(activeWeek.startDate)
            )
              ? json.data.find(
                  (performance) =>
                    performance.week_start_date ===
                    toWeekStartDate(
                      moment(activeDate),
                      activeClient.start_day
                    ).format('YYYY-MM-DD')
                )
              : null;
          setScores(filtered);
        } else {
          console.log(response.message);
        }
      } catch (error) {
        console.log(error);
      }
    };

    fetchAssociatePerformance();
  }, [token, associate, activeDate]);

  return (
    <div className="w-100 mt-4">
      {scores ? (
        <div className="table-responsive border rounded">
          <table className="table table-borderless m-0">
            <thead className="border-bottom">
              <tr>
                <th className="border-right">
                  Week {toWeekInt(activeWeek.startDate, activeClient.start_day)}
                </th>
                <th className="border-right">Weightage</th>
                <th>Score</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td className="border-right fw-bold">
                  Attendance Rate
                </td>
                <td className="border-right text-center">35%</td>
                <td className="text-center">{scores.attendance_rate}%</td>
              </tr>
              <tr>
                <td className="border-right fw-bold">Fill Rate</td>
                <td className="border-right text-center">35%</td>
                <td className="text-center">{scores.fill_rate}%</td>
              </tr>
              <tr>
                <td className="border-right fw-bold">Pick Rate</td>
                <td className="border-right text-center">30%</td>
                <td className="text-center">{scores.pick_rate}%</td>
              </tr>
              <tr className="border-top">
                <td
                  colSpan="2"
                  className="border-right text-end fw-bold"
                >
                  Overall
                </td>
                <td className="text-center">{scores.performance_score}%</td>
              </tr>
            </tbody>
          </table>
        </div>
      ) : (
        <div className="container text-center">
          <i className="text-muted">
            Pick Rates can be uploaded once the week has ended.
          </i>
        </div>
      )}
    </div>
  );
};

export default PerformanceTab;
